import { addDays, isSameDay, startOfDay } from 'date-fns';
import { useEffect, useState } from 'react';

/**
 * The current moment, read again once the local calendar day turns: at the
 * next local midnight, and when the page becomes visible on a later day,
 * because a sleeping machine fires its timers late. Between those it holds
 * still, so everything rendered against it agrees on one date.
 */
export function useToday(): Date {
    const [today, setToday] = useState(() => new Date());

    useEffect(() => {
        let timer: number | undefined;
        const refreshIfDayTurned = () => {
            const now = new Date();
            if (isSameDay(now, today)) {
                // A timer can fire a moment early; wait for the turn again.
                scheduleAtMidnight();
            } else {
                setToday(now);
            }
        };
        const scheduleAtMidnight = () => {
            window.clearTimeout(timer);
            timer = window.setTimeout(
                refreshIfDayTurned,
                startOfDay(addDays(today, 1)).getTime() - Date.now()
            );
        };
        scheduleAtMidnight();
        document.addEventListener('visibilitychange', refreshIfDayTurned);
        return () => {
            window.clearTimeout(timer);
            document.removeEventListener(
                'visibilitychange',
                refreshIfDayTurned
            );
        };
    }, [today]);

    return today;
}
